import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 brand-focus",
  {
    variants: {
      variant: {
        default: "btn-primary",
        destructive: "bg-red-600 text-white hover:bg-red-700",
        outline: "btn-outline",
        ghost: "btn-ghost",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

export const Button = ({
  className,
  variant,
  size,
  ...props
}: ButtonProps) => (
  <button className={cn(buttonVariants({ variant, size }), className)} {...props} />
);
